<template>
    <div :class="{ 'is-active': active }" class="modal" @dblclick.stop>
        <div class="modal-background" />
        <div :class="`lb-modal-card_${componentType}`" class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title has-text-centered">
                    {{ $t(`creation.${componentType}`) }}
                </p>
            </header>
            <section class="modal-card-body">
                <div
                    v-if="!errorDescription"
                    class="notification is-info is-light"
                >
                    <p v-t="infoBlockText"></p>
                </div>
                <div v-else class="notification is-error is-light">
                    <button
                        class="delete"
                        @click="errorDescription = null"
                    ></button>
                    <p>{{ errorDescription }}</p>
                </div>
                <component
                    :is="requestedComponent"
                    slot="input"
                    v-model="inputValue"
                    :placeholder="placeholder"
                    :from-clipboard="fromClipboard"
                    :paste-value="pasteValue"
                    :advanced-options="true"
                    :locations="locations"
                    @uploading="
                        uploading = true;
                        hasErrors = false;
                        errorDescription = null;
                    "
                    @error="handleError"
                    @valid="(hasErrors = false), (errorDescription = null)"
                    @input="
                        uploading = false;
                        errorDescription = null;
                    "
                />
            </section>
            <footer class="modal-card-foot">
                <div class="buttons container is-centered">
                    <button
                        v-t="'creation.cancel'"
                        class="button is-link is-uppercase"
                        @click.prevent.stop="cancelAction"
                    />
                    <button
                        v-t="'creation.save'"
                        :disabled="!inputValue"
                        :class="{
                            'is-loading': uploading,
                            'is-danger': hasErrors,
                            'disabled': !inputValue
                        }"
                        class="button is-primary is-uppercase"
                        @click.prevent.stop="emitInput"
                    />
                </div>
            </footer>
        </div>
    </div>
</template>

<script>
import InputURL from '@/components/InputURL';
import InputURLButton from '@/components/InputURLButton';
import InputRitchURL from '@/components/InputRitchURL';
import InputMap from '@/components/InputMap';
import InputImage from '@/components/InputImage';
import InputVideo from '@/components/InputVideo';
import InputAudio from '@/components/InputAudio';
//import InputDraw from "@/components/InputDraw";
import InputTags from '@/components/InputTags';
import InputFile from '@/components/InputFile';
import InputEmbed from '@/components/InputEmbed';
import InputSingleImage from '@/components/InputSingleImage';
import InputRichText from '@/components/InputRichText';
import InputFileButton from '@/components/InputFileButton';

import _ from 'underscore';
export default {
    components: {
        InputURL,
        InputMap,
        InputImage,
        InputVideo,
        InputAudio,
        InputFile,
        InputURLButton,
        InputRitchURL,
        //InputDraw,
        InputTags,
        InputEmbed,
        InputSingleImage,
        InputRichText,
        InputFileButton,
    },
    props: {
        active: { type: Boolean, default: false },
        fromClipboard: { type: Boolean, default: false },
        componentType: { type: String, default: undefined },
        placeholder: { type: String, default: '' },
        value: {
            type: [String, Array, FileList, File, Object],
            default: undefined,
        },
        locations: {
            type: Array,
            default() {
                return [];
            },
        },
    },
    data() {
        return {
            inputValue: undefined,
            uploading: false,
            hasErrors: false,
            pasteValue: undefined,
            errorDescription: undefined,
        };
    },
    computed: {
        requestedComponent() {
            switch (this.componentType) {
                case 'map':
                case 'location':
                    return InputMap;

                case 'url': {
                    return InputURL;
                }
                case 'image':
                case 'images':
                    return InputImage;

                case 'video': {
                    return InputVideo;
                }
                case 'audio': {
                    return InputAudio;
                }
                case 'draw': {
                    return console.log('not implemented');
                    //return InputDraw;
                }
                case 'tags': {
                    return InputTags;
                }
                case 'files': {
                    return InputFile;
                }
                case 'embed': {
                    return InputEmbed;
                }
                case 'singleImage': {
                    return InputSingleImage;
                }
                case 'urlButton': {
                    return InputURLButton;
                }
                case 'ritchUrl': {
                    return InputRitchURL;
                }
                case 'content': {
                    return InputRichText;
                }
                case 'fileButton': {
                    return InputFileButton;
                }
                default:
                    return undefined;
            }
        },
        infoBlockText() {
            // console.log(this.componentType)
            /*if (this.$store.getters.project.type == 'treasurehunt') {
                return `creation.clue_hint`;
            }*/
            if (this.$store.getters.project.suggestedTags && this.componentType=="tags") {
                return `creation.tags_and_suggested_tags_hint`;
            }
            return `creation.${this.componentType}_hint`;
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                if (val) {
                    if (typeof val != 'string') {
                        this.inputValue = _.clone(val); //{ ...val };
                    } else {
                        this.inputValue = val;
                    }
                }
            },
        },
    },
    destroyed() {
        this.inputValue = undefined;
    },
    methods: {
        emitInput() {
            if(this.componentType=='location'&&!this.inputValue){ // prevent save without position
                console.log("no location data")
                return;
            }
            if (!this.hasErrors) {
                this.$emit('input', this.inputValue);
            }
        },
        handleError(err) {
            this.hasErrors = true;
            this.uploading = false;
            this.errorDescription = this.$t(`Error.${err}`);
        },
        cancelAction() {
            if (this.componentType == 'location') {
                this.$emit('cancel');
            } else {
                this.$emit('update:active', false);
            }
        },
    },
};
</script>

<style>
.modal-card {
    max-width: 90%;
    max-height: 80%;
}
.lb-modal-card_location {
    width: 90% !important;
    height: 90% !important;
}
</style>
